import React, { useEffect, useState, useRef } from "react";
import { Divider } from "antd";
import { Hidden, LinearProgress, Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { DatePicker, Space } from "antd";
import { Spinner, Table, Button, Modal } from "react-bootstrap";
import { upperCase } from "lodash";
const { RangePicker } = DatePicker;

const YearFeeReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setreportData] = useState([]);
  var [logomodel, setlogomodel] = useState("");

  const [Start_date, setStartDate] = useState([]);
  const [End_Date, setEndDate] = useState([]);
  var [logomodel1, setlogomodel1] = useState("");
  const getMonthName = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}-${d.getFullYear()}`;
  };

  let authtoken = localStorage.getItem("userToken");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChanger = (day, date) => {
    let startDate = date[0] + "-01";
    let endDate = date[1] + "-01";
    var start = startDate.split("-");
    var end = endDate.split("-");
    setStartDate(startDate);
    setEndDate(endDate);
  };
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();

  const handleShow = () => {
    setLoading(true);
    const data = {
      Start_Date: Start_date,
      End_Date: End_Date,
    };
    fetch(`${baseUrl}/yearly-fee-report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setreportData(data.payload);
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        {loading ? <LinearProgress /> : null}

        <div className="row mt-3">
          <div className="col-md-3">
            <label>
              <b>Select Date Range</b>
            </label>
            <RangePicker
              style={{ height: "40px" }}
              picker="month"
              onChange={(day, date) => handleChanger(day, date)}
            />
          </div>
          <div className="col-md-2 d-flex mt-9">
            <button onClick={handleShow} className="btn btn-primary">
              Search
            </button>

            {reportData?.length > 0 ? (
              <ReactToPrint
                documentTitle={`salary slip Report`}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    style={{ marginLeft: "10px" }}
                    className="btn btn-primary w-105px mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}
          </div>
        </div>

        <Divider />

        <div>
          <Paper
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              padding: "15px",
            }}
          >
            <Table responsive>
              <thead>
                <tr className="text-center">
                  <th>Sr No.</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>Mobile No</th>
                  <th>Monthly Fee</th>
                  <th>Class</th>
                  <th>Months</th>
                  <th>Last Month</th>
                  <th>Fee Paid</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((campus, i) => (
                  <tr key={i} className="text-center">
                    <td>{i + 1}</td>
                    <td>{campus.student.name}</td>
                    <td>{campus.student.father_name}</td>
                    <td>{campus.student.mobile_no}</td>

                    <td>{campus.student.student_liable_fees[0].amount}</td>

                    <td>
                      {campus.student.student_class.name}-
                      {campus.student.global_section.name}
                    </td>
                    <td>{campus.months}</td>
                    <td>
                      {getMonthName(
                        campus.student.fee_challan_details_last.fee_month
                      )}
                    </td>
                    <td>{campus.total}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Paper>
        </div>

        {/* //for print///// */}
        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div className="mainContainer">
            <div className="logocontainer" style={{ height: "100px" }}>
              <div className="d-flex">
                <div className="">
                  <img
                    style={{ height: 100, width: 100, paddingLeft: "20px" }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div style={{ padding: "10px" }}>
                  <h1>{unitName}</h1>
                  <h3>Yearly Fee Progress Report</h3>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <Table
                style={{
                  fontSize: "16px",
                  whiteSpace: "normal",
                  padding: "1px",
                  marginTop: "15px",
                }}
                responsive
              >
                <thead
                  style={{
                    fontSize: "16px",
                    whiteSpace: "normal",
                    padding: "1px",
                  }}
                >
                  <tr
                    id="tbl"
                    className="text-center"
                    style={{
                      fontSize: "16px",
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <th
                      width="5%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Sr No
                    </th>
                    <th
                      width="5%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Admin_ID
                    </th>
                    <th
                      width="20%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Student Name
                    </th>
                    <th
                      width="20%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Father Name
                    </th>
                    <th
                      width="10%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Mobile No
                    </th>
                    <th
                      width="5%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Fee
                    </th>
                    <th
                      width="12%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Class
                    </th>
                    <th
                      width="10%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Last Month
                    </th>
                    <th
                      width="5%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Months
                    </th>
                    <th
                      width="5%"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      Paid
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.map((campus, i) => (
                    <tr
                      key={i}
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        padding: "1px",
                        borderTop: "1px solid black",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {i + 1}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.student.admission_id}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {/* {campus.student.name} */}
                        {campus.student.name.length > 15
                          ? campus.student.name.substring(0, 15) + "..."
                          : campus.student.name}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {/* {campus.student.father_name} */}
                        {campus.student.father_name.length > 15
                          ? campus.student.father_name.substring(0, 15) + "..."
                          : campus.student.father_name}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.student.mobile_no}
                      </td>

                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.student.student_liable_fees[0].amount}
                      </td>

                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.student.student_class.name.length > 7
                          ? campus.student.student_class.name.substring(0, 5)
                          : campus.student.student_class.name}
                        -
                        {campus.student.global_section.name.length > 7
                          ? campus.student.global_section.name.substring(0, 5)
                          : campus.student.global_section.name}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {getMonthName(
                          campus.student.fee_challan_details_last.fee_month
                        )}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.months}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {campus.total}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default YearFeeReport;
